import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cart-black",
  "use": "icon-cart-black-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cart-black\">\n    <title>icon/基础图标/购物车2</title>\n    <g id=\"icon-cart-black_icon/基础图标/购物车2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle id=\"icon-cart-black_椭圆形\" fill=\"#2C2C2E\" cx=\"33.5373134\" cy=\"83.7761194\" r=\"6\" />\n        <polyline id=\"icon-cart-black_路径\" stroke=\"#2C2C2E\" stroke-width=\"10\" stroke-linecap=\"square\" stroke-linejoin=\"round\" points=\"11 11 16.3930555 11 20 28\" />\n        <polygon id=\"icon-cart-black_路径\" stroke=\"#2C2C2E\" stroke-width=\"10\" fill=\"#2C2C2E\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"20 28 28.8888889 68 75.1111111 68 84 28\" />\n        <circle id=\"icon-cart-black_椭圆形\" fill=\"#2C2C2E\" cx=\"68.9552239\" cy=\"83.7761194\" r=\"6\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cart-black.svg
// module id = tgOc
// module chunks = 3